import React from 'react';
import {
    Create, SimpleForm,
    TextInput, BooleanInput,
} from 'react-admin';

import { required } from '../../util/fieldValidation';

import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/showStyles';

const MultiDistrictsCreate = withStyles(styles)(({ classes,...props }) => (
    <Create {...props}>
        <SimpleForm submitOnEnter={false} >
            <TextInput
                source='MultiDistrictName'
                validate={[required()]}
                formClassName={classes.inlineBlock}
            />
            <BooleanInput
                source='Active'
                defaultValue={true}
            />
        </SimpleForm>
    </Create>
));
export default MultiDistrictsCreate;